// Builds a CSV file in the browser and starts the download. Uses a semicolon as the
// separator and a UTF-8 BOM so Excel with Indonesian regional settings opens it
// in columns straight away.

type Cell = string | number | null | undefined

const escapeCell = (cell: Cell): string => {
    if (cell === null || cell === undefined) return ''

    const text = String(cell)

    if (/[";\n\r]/.test(text)) return `"${text.replace(/"/g, '""')}"`

    return text
}

export const downloadCsv = (filename: string, header: string[], rows: Cell[][]): void => {
    const lines = [header, ...rows].map((row) => row.map(escapeCell).join(';'))
    const blob = new Blob([`﻿${lines.join('\r\n')}`], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(text)
        return true
    }
    catch {
        return false
    }
}
